import * as SolidIcons from "@/icons/solid";

const CustomSingleValue = (props) => {
	let { children, className, cx, getStyles, innerRef, innerProps, data } = props;

	const styles = getStyles("singleValue", props);

	const Icon = data?.icon ? SolidIcons[data.icon] : null;

	return (
		<div
			style={{
				...styles,
			}}
			className={cx(
				{
					"singleValue": true,
				},
				className,
				"flex items-center"
			)}
			ref={innerRef}
			{...innerProps}
		>
			{Icon && <Icon className="h-8 w-8 mr-3 ml-1" />}
			{children}
		</div>
	);
};

export { CustomSingleValue };
